/**
 * Defines the rendering and height calculation behavior of subcomponents when `renderRowSubComponent` is used.
 */
export let AnalyticalTableSubComponentsBehavior = /*#__PURE__*/function (AnalyticalTableSubComponentsBehavior) {
  AnalyticalTableSubComponentsBehavior["Expandable"] = "Expandable";
  AnalyticalTableSubComponentsBehavior["Visible"] = "Visible";
  AnalyticalTableSubComponentsBehavior["IncludeHeight"] = "IncludeHeight";
  AnalyticalTableSubComponentsBehavior["IncludeHeightExpandable"] = "IncludeHeightExpandable";
  return AnalyticalTableSubComponentsBehavior;
}({});